import React from 'react';
export function Level1Detail() {
  const tomos = [{
    icon: '🧠',
    num: 'Tomo 01',
    title: 'Método de Estudio y Organización de la Carrera',
    desc: 'Active Recall, Spaced Repetition, Anki, técnica Feynman y cómo planificar toda la carrera desde primer año.'
  }, {
    icon: '🦴',
    num: 'Tomo 02',
    title: 'Anatomía Filtrada — Lo que sí entra',
    desc: 'Miembro superior, inferior, tórax, abdomen, cabeza y cuello. Solo los 50 temas que siempre preguntan, con mnemotecnias.'
  }, {
    icon: '❤️',
    num: 'Tomo 03',
    title: 'Fisiología de Supervivencia',
    desc: 'Cardiovascular, respiratorio, renal, nervioso, endócrino y digestivo. Con las preguntas más frecuentes de final.'
  }, {
    icon: '💊',
    num: 'Tomo 04',
    title: 'Farmacología — El Repaso Definitivo',
    desc: 'Farmacocinética, farmacodinamia, SNA, antibióticos, cardiovascular, embarazo, insuficiencia renal y analgésicos.'
  }, {
    icon: '🩺',
    num: 'Tomo 05',
    title: 'Introducción a la Clínica',
    desc: 'Historia clínica, semiología, signos vitales, razonamiento clínico, síndromes frecuentes y urgencias: RCP, shock, ACV.'
  }, {
    icon: '🎓',
    num: 'Tomo 06',
    title: 'Organización de la Carrera Completa',
    desc: 'Mapa de la carrera, cómo elegir cátedras, salud mental, sistema de residencias y orientación vocacional.'
  }];
  const bonos = [{
    icon: '📅',
    title: 'Plan de Estudio Semana a Semana',
    desc: 'Organizá cada semana del año sin improvisar qué estudiar ni cuándo.',
    cover: 'bg-emerald-600',
    spine: 'bg-emerald-800'
  }, {
    icon: '🃏',
    title: 'Fichas de Memoria Imprimibles',
    desc: 'Tarjetas listas para repasar con Active Recall donde estés.',
    cover: 'bg-blue-600',
    spine: 'bg-blue-800'
  }, {
    icon: '📱',
    title: 'Guía de Recursos Digitales',
    desc: 'Las mejores apps, atlas y herramientas para estudiar Medicina.',
    cover: 'bg-indigo-600',
    spine: 'bg-indigo-800'
  }, {
    icon: '✅',
    title: 'Checklist de Parcial y Final',
    desc: 'Verificá que estudiaste todo lo que el docente realmente toma.',
    cover: 'bg-amber-600',
    spine: 'bg-amber-800'
  }, {
    icon: '🧠',
    title: 'Mnemotecnia Médica Completa',
    desc: 'Reglas y trucos para no olvidarte nunca más lo importante.',
    cover: 'bg-rose-600',
    spine: 'bg-rose-800'
  }, {
    icon: '📋',
    title: 'Plantilla de Organización y Tracker',
    desc: 'Seguí tu progreso y mantené toda la carrera bajo control.',
    cover: 'bg-slate-700',
    spine: 'bg-slate-900'
  }];
  return <section className="w-full bg-white py-12 md:py-20 px-4" data-id="element-260">
      <div className="max-w-5xl mx-auto" data-id="element-261">
        <div className="text-center mb-16" data-id="element-262">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-blue mb-2" data-id="element-263">
            Médico en Proceso™: Nivel 1
          </h2>
          <div className="text-xl font-bold text-slate-800 mb-4" data-id="element-264">
            6 tomos · 6 bonos · +360 páginas
          </div>
          <p className="text-lg text-slate-600" data-id="element-265">
            El contenido central de toda la carrera de Medicina...
          </p>
        </div>

        <div className="mb-16" data-id="element-266">
          <h3 className="text-2xl font-bold text-slate-900 mb-8 border-b pb-2" data-id="element-267">
            📚 Los 6 Tomos / +360 páginas
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-268">
            {tomos.map((tomo, idx) => <div key={idx} className="bg-slate-50 rounded-xl p-6 border border-slate-100 flex gap-4" data-id="element-269">
                <div className="text-4xl shrink-0" data-id="element-270">{tomo.icon}</div>
                <div data-id="element-271">
                  <div className="inline-block bg-brand-blue text-white text-xs font-bold px-2 py-1 rounded mb-2" data-id="element-272">
                    {tomo.num}
                  </div>
                  <h4 className="font-bold text-slate-900 mb-2" data-id="element-273">
                    {tomo.title}
                  </h4>
                  <p className="text-sm text-slate-600" data-id="element-274">{tomo.desc}</p>
                </div>
              </div>)}
          </div>
        </div>

        <div className="mb-16" data-id="element-275">
          {/* Encabezado estilo "regalos" */}
          <div className="text-center mb-10" data-id="element-276">
            <h3 className="text-3xl md:text-5xl font-extrabold text-slate-900 tracking-tight mb-3" data-id="element-277">
              🎁 + 6 Regalos Estratégicos
            </h3>
            <p className="text-lg md:text-xl text-slate-500 font-medium mb-6" data-id="element-278">
              Incluidos sin costo extra · Valor real del pack
            </p>
            <div className="inline-flex items-center gap-2 bg-brand-amber text-white font-bold text-sm md:text-base px-6 py-3 rounded-full shadow-md" data-id="element-279">
              🎁 GRATIS POR EL DÍA DE HOY
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-280">
            {bonos.map((bono, idx) => <div key={idx} className="bg-white rounded-2xl p-6 border border-slate-100 shadow-sm flex flex-col items-center text-center" data-id="element-281">
                {/* Tapa de libro (mockup CSS) */}
                <div className="relative mb-5" data-id="element-282">
                  <div className={`relative w-40 h-52 ${bono.cover} rounded-lg rounded-l-sm shadow-xl overflow-hidden flex flex-col justify-between p-4 text-white`} data-id="element-283">
                    {/* lomo del libro */}
                    <div className={`absolute top-0 left-0 h-full w-2.5 ${bono.spine}`} data-id="element-284" />
                    <div className="text-3xl pl-3" data-id="element-285">{bono.icon}</div>
                    <div className="pl-3" data-id="element-286">
                      <div className="font-bold text-lg leading-tight" data-id="element-287">
                        Bonus {idx + 1}
                      </div>
                      <div className="mt-3 border-t border-white/30 pt-2 text-[10px] tracking-widest font-semibold text-white/80" data-id="element-288">
                        MÉDICO EN PROCESO™
                      </div>
                    </div>
                  </div>
                </div>

                {/* Etiqueta GRATIS */}
                <span className="inline-block bg-green-100 text-green-700 font-bold text-xs tracking-wide px-4 py-1.5 rounded-full mb-3" data-id="element-289">
                  GRATIS
                </span>

                <h4 className="font-bold text-slate-900 text-lg mb-2 leading-snug" data-id="element-290">
                  {bono.icon} Bonus {idx + 1} — {bono.title}
                </h4>
                <p className="text-sm text-slate-500 leading-relaxed" data-id="element-291">
                  {bono.desc}
                </p>
              </div>)}
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-4 md:gap-8 mb-12 border-y border-slate-100 py-6" data-id="element-292">
          <div className="flex items-center gap-2 text-sm font-medium text-slate-600" data-id="element-293">
            <span data-id="element-294">📄</span> 100% PDF
          </div>
          <div className="flex items-center gap-2 text-sm font-medium text-slate-600" data-id="element-295">
            <span data-id="element-296">⚡</span> Acceso inmediato
          </div>
          <div className="flex items-center gap-2 text-sm font-medium text-slate-600" data-id="element-297">
            <span data-id="element-298">🇦🇷</span> Hecho para Argentina
          </div>
          <div className="flex items-center gap-2 text-sm font-medium text-slate-600" data-id="element-299">
            <span data-id="element-300">🏫</span> Compatible con UBA · UNC · UNLP y más
          </div>
        </div>

        <div className="text-center" data-id="element-301">
          <p className="text-lg italic text-slate-500 mb-2" data-id="element-302">
            ¿Querés más que el contenido?
          </p>
          <div className="text-slate-400 text-2xl animate-bounce" data-id="element-303">↓</div>
        </div>
      </div>
    </section>;
}